var map = {
	"./pos-leaderboard-badge-rank-1.svg": "b2ed",
	"./pos-leaderboard-badge-rank-2.svg": "bc0e",
	"./pos-leaderboard-badge-rank-3.svg": "afa6",
	"./pos-leaderboard-badge-rank-4.svg": "7d48",
	"./pos-leaderboard-badge-rank-5.svg": "3360"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c525";